import { Directive } from '@angular/core';

@Directive({
    selector: '[nbPrefix]',
    standalone: false
})
export class NbPrefixDirective {
}
